import HighlightedAppointment from './HighlightedAppointment';

import './index.css';

export default HighlightedAppointment;
